import { equals } from 'ramda';
import { createSelectorCreator, defaultMemoize } from 'reselect';

/**
 * Use this to perform deep equality check if the value has been changed or not.
 * https://github.com/reduxjs/reselect#createselectorcreatormemoize-memoizeoptions
 */
export const createDeepEqualSelector = createSelectorCreator(defaultMemoize, equals);
